import React, { ReactNode } from 'react';
import { Description, Field } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';

interface Props {
    title: string;
    hint?: string;
    children: ReactNode;
    /** Overrides the row's ContactBox inset where the host card has its own. */
    className?: string;
}

const ContactSettingRow = ({ title, hint, children, className }: Props) => (
    <Field
        as="div"
        className={twMerge(
            'mx-4 flex grow items-start justify-between gap-x-3 p-2',
            className,
        )}
    >
        {/* The text column takes all the shrinking, so a long hint in a
         *  narrow card (the 360px ticket panel) never squeezes the switch. */}
        <div className="flex min-w-0 flex-1 flex-col">
            <div className="text-gray-800">{title}</div>
            {hint ? (
                <Description as="p" className="text-xs text-gray-500">
                    {hint}
                </Description>
            ) : null}
        </div>
        {children}
    </Field>
);

export default ContactSettingRow;
